import { useSuspenseQuery } from '@tanstack/react-query';

import { getAbstractValidationHistoryOptions } from '@/module/Author/Abstract/Validation/model/AbstractValidationModel';

import { Id } from '@feature/utils';
import { ValidationHistoryContent } from '@feature/validation/ValidationHistoryContent';

interface AbstractValidationHistoryProps {
  abstractId: Id;
}

export function AbstractValidationHistory({ abstractId }: AbstractValidationHistoryProps) {
  const { data: history } = useSuspenseQuery(getAbstractValidationHistoryOptions(abstractId));

  return <ValidationHistoryContent history={history} />;
}
